// src/components/filter.
import React, { useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/TableContainer"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  Input,
  InputGroup,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import Select from "react-select"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { useFormik } from "formik"
import * as Yup from "yup"
import { Link } from "react-router-dom"

const Feedbackcallingdashboardforoperation = () => {
  const [toggleSwitch, settoggleSwitch] = useState(true)
  //Grid form
  const formik = useFormik({
    initialValues: {
      firstname: "",
      email: "",
      password: "",
      city: "",
      state: "",
      zip: "",
      check: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("This field is required"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(RegExp("(.*[a-z].*)"), "At least lowercase letter")
        .matches(RegExp("(.*[A-Z].*)"), "At least uppercase letter")
        .matches(RegExp("(.*[0-9].*)"), "At least one number")
        .required("This field is required"),
      city: Yup.string().required("This field is required"),
      state: Yup.string().required("This field is required"),
      zip: Yup.string().required("This field is required"),
      check: Yup.string().required("This field is required"),
    }),

    onSubmit: values => {
      // console.log("value", values.password);
    },
  })

  const columns = useMemo(
    () => [
      {
        header: "Date",
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Telecaller Name",
        accessorKey: "telename",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Target",
        accessorKey: "target",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Call Executed",
        accessorKey: "callexe",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Assign or Deassign",
        accessorKey: "oldcustact",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <div className="form-check form-switch form-switch-md mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizemd"
                defaultChecked
                onClick={e => {
                  settoggleSwitch(!toggleSwitch)
                }}
              />
            </div>
          )
        },
      },
      {
        header: "Start or Stop Calling",
        accessorKey: "oldcustact",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <div className="form-check form-switch form-switch-md mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizemd"
                defaultChecked
                onClick={e => {
                  settoggleSwitch(!toggleSwitch)
                }}
              />
            </div>
          )
        },
      },
    ],
    []
  )

  const data = [
    {
      date: "1-1-2024",
      telename: "Anuja Pawar",
      target: "10",
      callexe: "10",
      status: "Pending",
    },
  ]

  //usestate
  const flatpickrRef = useRef(null)

  const showValue = () => {
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.open()
    }
  }

  const closeValue = () => {
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.close()
    }
  }
  //usestate
  const [selectedGroup, setselectedGroup] = useState(null)

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      label: "Picnic",
      options: [
        { label: "Mustard", value: "Mustard" },
        { label: "Ketchup", value: "Ketchup" },
        { label: "Relish", value: "Relish" },
      ],
    },
    {
      label: "Camping",
      options: [
        { label: "Tent", value: "Tent" },
        { label: "Flashlight", value: "Flashlight" },
        { label: "Toilet Paper", value: "Toilet Paper" },
      ],
    },
  ]

  //meta title
  document.title = "Data Tables | Skote - React Admin & Dashboard Template"

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Breadcrumbs
          title="Forms"
          breadcrumbItem="Feedback Calling Dashboard for Operation"
        />
        <Row>
          <Col xl={12}>
            <div className="page-content">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center justify-content-start">
                    <div className="flex-shrink-0">
                      <CardTitle className="mb-4">
                        Total Feedback Calling: Status
                        <div className="form-check form-switch form-switch-md mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizemd"
                            defaultChecked
                            onClick={e => {
                              settoggleSwitch(!toggleSwitch)
                            }}
                          />
                        </div>
                      </CardTitle>
                    </div>
                  </div>

                  <div className="">
                    <TableContainer
                      columns={columns}
                      data={data || []}
                      isGlobalFilter={true}
                      isPagination={true}
                      SearchPlaceholder="27 records..."
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers"
                      tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
Feedbackcallingdashboardforoperation.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Feedbackcallingdashboardforoperation
